"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Enter: '\r',
  ArrowLeft: '\x1b[D',
  ArrowRight: '\x1b[C',
  ArrowUp: '\x1b[A',
  ArrowDown: '\x1b[B',
  PgUp: '\x1b[5~',
  PgDown: '\x1b[6~',
  Home: '\x1b[1~',
  End: '\x1b[4~',
  Backspace: '\b',
  CtrlC: '\x03',
  CtrlP: '\x10',
  CtrlU: '\x15',
  CtrlZ: '\x1a'
};
exports["default"] = _default;